module.exports.stateArray = {
  AL: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  AK: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  AZ: {licensed: true, of: "greater", pmt: 0, flat: 35, top: 35},
  AR: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  CA: {licensed: true, of: "lesser", pmt: .08, flat: 35, top: 35},
  CO: {licensed: true, of: "account", pmt: 0, flat: 10, top: 50},
  CT: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  DE: {licensed: true, of: "account", pmt: 0, flat: 10, top: 50},
  FL: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  GA: {licensed: true, of: "greater", pmt: .075, flat: 0, top: 50},
  HI: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  ID: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  IL: {licensed: true, of: "flat", pmt: 0, flat: 50, top: 50},
  IN: {licensed: true, of: "totaldebt", pmt: .15, flat: 0, top: 50},
  IA: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  KS: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  KY: {licensed: true, of: "greater", pmt: .085, flat: 30, top: 50},
  LA: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  ME: {licensed: true, of: "flat", pmt: 0, flat: 40, top: 40},
  MD: {licensed: true, of: "creditor", pmt: 0, flat: 8, top: 40},
  MA: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  MI: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  MN: {licensed: true, of: "lesser", pmt: .15, flat: 50, top: 50},
  MS: {licensed: true, of: "flat", pmt: 0, flat: 30, top: 30},
  MO: {licensed: true, of: "greater", pmt: .08, flat: 35, top: 50},
  MT: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  NV: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  NE: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  NH: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  NJ: {licensed: true, of: "flat", pmt: 0, flat: 25, top: 25},
  NM: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  NY: {licensed: true, of: "flat", pmt: 0, flat: 35, top: 35},
  NC: {licensed: true, of: "greater", pmt: .10, flat: 0, top: 40},
  ND: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  OH: {licensed: true, of: "greater", pmt: .085, flat: 30, top: 50},
  OK: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  OR: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  PA: {licensed: true, of: "account", pmt: 0, flat: 10, top: 50},
  RI: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  SC: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  SD: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50},
  TX: {licensed: true, of: "creditor", pmt: 0, flat: 10, top: 50},
  TN: {licensed: true, of: "account", pmt: 0, flat: 10, top: 50},
  UT: {licensed: false, of: "greater", pmt: .075, flat: 35, top: 50},
  VT: {licensed: true, of: "greater", pmt: .10, flat: 0, top: 50},
  VA: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 50},
  WA: {licensed: true, of: "greater", pmt: .15, flat: 0, top: 25},
  WV: {licensed: true, of: "greater", pmt: .07, flat: 0, top: 50},
  WI: {licensed: true, of: "greater", pmt: .10, flat: 0, top: 50},
  WY: {licensed: true, of: "greater", pmt: .075, flat: 35, top: 50}
};
const insData = {
  "4515": {
    18: 41152,
    19: 40671,
    20: 40061,
    21: 39122,
    22: 38098,
    23: 37615,
    24: 37085,
    25: 36565,
    26: 35711,
    27: 34839,
    28: 34054,
    29: 33250,
    30: 32576,
    31: 31424,
    32: 30473,
    33: 29572,
    34: 28606,
    35: 27797,
    36: 26542,
    37: 25184,
    38: 23743,
    39: 22447,
    40: 21276,
    41: 19791,
    42: 18394,
    43: 17076,
    44: 15816,
    45: 14667,
    46: 13384,
    47: 12274,
    48: 11283
  },
  "6015": {
    18: 56391,
    19: 55733,
    20: 54899,
    21: 53613,
    22: 52211,
    23: 51550,
    24: 50826,
    25: 50114,
    26: 48944,
    27: 47750,
    28: 46677,
    29: 45576,
    30: 44654,
    31: 43076,
    32: 41774,
    33: 40541,
    34: 39218,
    35: 38111,
    36: 36392,
    37: 34533,
    38: 32558,
    39: 30783,
    40: 29179,
    41: 27145,
    42: 25231,
    43: 23425,
    44: 21699,
    45: 20125,
    46: 18368,
    47: 16848,
    48: 15490
  },
  "7515": {
    18: 71630,
    19: 70794,
    20: 69736,
    21: 68103,
    22: 66323,
    23: 65484,
    24: 64564,
    25: 63662,
    26: 62176,
    27: 60661,
    28: 59299,
    29: 57901,
    30: 56730,
    31: 54728,
    32: 53075,
    33: 51509,
    34: 49831,
    35: 48425,
    36: 46242,
    37: 43882,
    38: 41373,
    39: 39119,
    40: 37083,
    41: 34499,
    42: 32068,
    43: 29774,
    44: 27582,
    45: 25583,
    46: 23352,
    47: 21421,
    48: 19697
  },
  "8020": {
    18: 76709,
    19: 75815,
    20: 74682,
    21: 72933,
    22: 71027,
    23: 70129,
    24: 69145,
    25: 68179,
    26: 66588,
    27: 64965,
    28: 63506,
    29: 62010,
    30: 60757,
    31: 58612,
    32: 56842,
    33: 55166,
    34: 53368,
    35: 51863,
    36: 49525,
    37: 46998,
    38: 44312,
    39: 41899,
    40: 39717,
    41: 36951,
    42: 34347,
    43: 31891,
    44: 29543,
    45: 27402,
    46: 25013,
    47: 22946,
    48: 21100
  },
  "10025": {
    18: 97026,
    19: 95897,
    20: 94464,
    21: 92253,
    22: 89843,
    23: 88709,
    24: 87464,
    25: 86243,
    26: 84231,
    27: 82179,
    28: 80335,
    29: 78444,
    30: 76859,
    31: 74148,
    32: 71910,
    33: 69791,
    34: 67517,
    35: 65614,
    36: 62658,
    37: 59462,
    38: 56065,
    39: 53013,
    40: 50255,
    41: 46756,
    42: 43463,
    43: 40357,
    44: 37387,
    45: 34679,
    46: 31658,
    47: 29043,
    48: 26709
  },
  "12030": {
    18: 117346,
    19: 115980,
    20: 114248,
    21: 111574,
    22: 108660,
    23: 107288,
    24: 105783,
    25: 104308,
    26: 101876,
    27: 99395,
    28: 97165,
    29: 94879,
    30: 92963,
    31: 89685,
    32: 86979,
    33: 84417,
    34: 81667,
    35: 79367,
    36: 75792,
    37: 71927,
    38: 67819,
    39: 64129,
    40: 60794,
    41: 56562,
    42: 52580,
    43: 48823,
    44: 45231,
    45: 41956,
    46: 38303,
    47: 35142,
    48: 32319
  }
};
module.exports.iaArray = [

  {display: "None Selected", cost: 0, fpda: 0},
  {
    display: "60.00 45 FSP & 15 FPDA", cost: 60, fpda: 15, cashAmounts: {
      0: 0,
      1: 169,
      2: 605,
      3: 1069,
      4: 1560,
      5: 2176,
      6: 2823,
      7: 3502,
      8: 4215,
      9: 4964,
      10: 5698,
      11: 6490,
      12: 7276,
      13: 8122,
      14: 8997,
      15: 9902,
      16: 10837,
      17: 11805,
      18: 12839,
      19: 13876,
      20: 14980
    }, insData: insData["4515"]
  },
  {
    display: "75.00 60 FSP & 15 FPDA", cost: 75, fpda: 15, cashAmounts: {
      0: 0,
      1: 169,
      2: 691,
      3: 1245,
      4: 1833,
      5: 2584,
      6: 3373,
      7: 4200,
      8: 5068,
      9: 5978,
      10: 6872,
      11: 7839,
      12: 8795,
      13: 9827,
      14: 10894,
      15: 11996,
      16: 13136,
      17: 14314,
      18: 15576,
      19: 16836,
      20: 18183
    },
    insData: insData["6015"]
  },
  {
    display: "90.00 75 FSP & 15 FPDA", cost: 90, fpda: 15, cashAmounts: {
      0: 0,
      1: 169,
      2: 776,
      3: 1421,
      4: 2105,
      5: 2993,
      6: 3923,
      7: 4898,
      8: 5921,
      9: 6993,
      10: 8046,
      11: 9188,
      12: 10314,
      13: 11532,
      14: 12791,
      15: 14091,
      16: 15434,
      17: 16823,
      18: 18312,
      19: 19797,
      20: 21385
    },
    insData: insData["7515"]
  },
  {
    display: "100.00 80 FSP & 20 FPDA", cost: 100, fpda: 20, cashAmounts: {
      0: 0,
      1: 226,
      2: 1035,
      3: 1895,
      4: 2807,
      5: 3991,
      6: 5233,
      7: 6535,
      8: 7900,
      9: 9330,
      10: 10735,
      11: 12261,
      12: 13763,
      13: 15389,
      14: 17069,
      15: 18804,
      16: 20597,
      17: 22450,
      18: 24438,
      19: 26418,
      20: 28539
    },
    insData: insData["8020"]
  },
  // {display: "115.00 90 FSP & 25 FPDA", cost: 115, fpda: 25, cashAmounts: {
  //     0: 0,
  //     1: 282,
  //     2: 1237,
  //     3: 2251,
  //     4: 3327,
  //     5: 4718,
  //     6: 6176,
  //     7: 7706,
  //     8: 9310,
  //     9: 10991,
  //     10: 12643,
  //     11: 14433,
  //     12: 16199,
  //     13: 18109,
  //     14: 20082,
  //     15: 22120,
  //     16: 24227,
  //     17: 26404,
  //     18: 28739,
  //     19: 31067,
  //     20: 33558
  //   }},
  {
    display: "125.00 100 FSP & 25 FPDA", cost: 125, fpda: 25, cashAmounts: {
      0: 0,
      1: 282,
      2: 1152,
      3: 2075,
      4: 3054,
      5: 4310,
      6: 5626,
      7: 7008,
      8: 8457,
      9: 9977,
      10: 11469,
      11: 13084,
      12: 14680,
      13: 16404,
      14: 18185,
      15: 20025,
      16: 21928,
      17: 23895,
      18: 26002,
      19: 28106,
      20: 30355
    },
    insData: insData["10025"]
  },
  // {display: "140.00 FSP SPB & 25 FPDA", cost: 140, fpda: 25, cashAmounts:{
  //     0: 0,
  //     1: 282,
  //     2: 1237,
  //     3: 2251,
  //     4: 3327,
  //     5: 4718,
  //     6: 6176,
  //     7: 7706,
  //     8: 9310,
  //     9: 10991,
  //     10: 12643,
  //     11: 14433,
  //     12: 16199,
  //     13: 18109,
  //     14: 20082,
  //     15: 22120,
  //     16: 24227,
  //     17: 26404,
  //     18: 28739,
  //     19: 31067,
  //     20: 33558
  //   }},
  {
    display: "150.00 120 FSP & 30 FPDA", cost: 150, fpda: 30, cashAmounts: {
      0: 0,
      1: 338,
      2: 1382,
      3: 2490,
      4: 3665,
      5: 5172,
      6: 6753,
      7: 8412,
      8: 10151,
      9: 11976,
      10: 13767,
      11: 15707,
      12: 17623,
      13: 19692,
      14: 21830,
      15: 24040,
      16: 26324,
      17: 28686,
      18: 31215,
      19: 33742,
      20: 36442
    },
    insData: insData["12030"]
  },
  // {display: "175.00 130 FSP & 45 FPDA", cost: 175, fpda: 45, cashAmounts:{
  //     0: 0,
  //     1: 508,
  //     2: 1788,
  //     3: 3147,
  //     4: 4589,
  //     5: 6399,
  //     6: 8300,
  //     7: 10296,
  //     8: 12392,
  //     9: 14591,
  //     10: 16749,
  //     11: 19076,
  //     12: 21387,
  //     13: 23873,
  //     14: 26443,
  //     15: 29102,
  //     16: 31851,
  //     17: 34696,
  //     18: 37733,
  //     19: 40779,
  //     20: 44025
  //   }},
  // {display: "190.00 140 FSP & 50 FPDA", cost: 190, fpda: 50, cashAmounts:{
  //     0: 0,
  //     1: 564,
  //     2: 1961,
  //     3: 3444,
  //     4: 5018,
  //     5: 6990,
  //     6: 9061,
  //     7: 11235,
  //     8: 13518,
  //     9: 15914,
  //     10: 18265,
  //     11: 20799,
  //     12: 23317,
  //     13: 26024,
  //     14: 28824,
  //     15: 31720,
  //     16: 34715,
  //     17: 37814,
  //     18: 41122,
  //     19: 44440,
  //     20: 47977
  //   }},
  // {display: "200.00 150 FSP & 50 FPDA", cost: 200, fpda: 50, cashAmounts:{
  //     0: 0,
  //     1: 564,
  //     2: 2018,
  //     3: 3562,
  //     4: 5200,
  //     5: 7262,
  //     6: 9427,
  //     7: 11700,
  //     8: 14086,
  //     9: 16590,
  //     10: 19047,
  //     11: 21698,
  //     12: 24329,
  //     13: 27161,
  //     14: 30089,
  //     15: 33116,
  //     16: 36247,
  //     17: 39486,
  //     18: 42946,
  //     19: 46414,
  //     20: 50112
  //   }},
  // {display: "250.00 170 FSP & 80 FPDA", cost: 250, fpda: 80, cashAmounts:{
  //     0: 0,
  //     1: 902,
  //     2: 2830,
  //     3: 4876,
  //     4: 7047,
  //     5: 9716,
  //     6: 12521,
  //     7: 15470,
  //     8: 18567,
  //     9: 21822,
  //     10: 25012,
  //     11: 28437,
  //     12: 31858,
  //     13: 35523,
  //     14: 39315,
  //     15: 43239,
  //     16: 47301,
  //     17: 51505,
  //     18: 55981,
  //     19: 60488,
  //     20: 65279
  //   }},
  // {display: "300.00 190 FSP & 110 FPDA", cost: 300, fpda: 110, cashAmounts:{
  //     0: 0,
  //     1: 1241,
  //     2: 3642,
  //     3: 6191,
  //     4: 8894,
  //     5: 12170,
  //     6: 15616,
  //     7: 19239,
  //     8: 23048,
  //     9: 27053,
  //     10: 30976,
  //     11: 35176,
  //     12: 39386,
  //     13: 43885,
  //     14: 48542,
  //     15: 53363,
  //     16: 58355,
  //     17: 63525,
  //     18: 69016,
  //     19: 74563,
  //     20: 80447
  //   }}
];


// WEBPACK FOOTER //
// ./src/containers/DebtCalc/programInfo.js